export default __webpack_public_path__ + "locales/cs/InviteDialog.json?hash=4c7f5fc5434e1e5460ebc60e1e878c53";